'use client';

import { RefObject, useEffect } from 'react';

export const useClickOutside = (
  containerRef: RefObject<HTMLElement | null>,
  onOutSideClick: () => void
) => {
  useEffect(() => {
    const handleMousedown = (e: Event) => {
      const target = e.target as Node;

      if (!target || !target.isConnected) {
        return;
      }

      if (containerRef?.current && !containerRef.current.contains(target)) {
        onOutSideClick();
      }
    };

    // Clicking non-focusable content focuses the nearest focusable ancestor
    // (e.g. `<main tabIndex={-1}>`). That is not a focus-out — a real tab-away
    // never lands on an ancestor of the container.
    const handleFocusin = (e: Event) => {
      if (!(e.target as Node)?.contains(containerRef.current)) {
        handleMousedown(e);
      }
    };

    window.addEventListener('mousedown', handleMousedown);
    window.addEventListener('focusin', handleFocusin);

    return () => {
      window.removeEventListener('mousedown', handleMousedown);
      window.removeEventListener('focusin', handleFocusin);
    };
  }, [containerRef, onOutSideClick]);
};
